export default "__VITE_ASSET__BZoZiSTK__"